import {
  ImageWidth as HygraphImageWidth,
  Maybe as HygraphMaybe,
} from '@/lib/types';

import { ImageWidth } from '@/enums/image-width';

const map: Partial<Record<HygraphImageWidth, ImageWidth>> = {
  [HygraphImageWidth.Auto]: ImageWidth.AUTO,
  [HygraphImageWidth.FullWidth]: ImageWidth.FULL_WIDTH,
};

export default function imageWidthTransformer(
  props: HygraphMaybe<HygraphImageWidth> | undefined
) {
  return props ? map[props] : undefined;
}
